import { render, staticRenderFns } from "./AlertServiceProviderContacts.vue?vue&type=template&id=39e4016b&scoped=true&lang=pug&"
import script from "./AlertServiceProviderContacts.vue?vue&type=script&lang=ts&"
export * from "./AlertServiceProviderContacts.vue?vue&type=script&lang=ts&"
import style0 from "./AlertServiceProviderContacts.vue?vue&type=style&index=0&id=39e4016b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4016b",
  null
  
)

export default component.exports